/* eslint no-use-before-define: 0 */

const { $ } = window;

$(document).ready(() => {
    $("#Filters").attr("aria-label", "Article search");
});
